import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import Button from 'components/Button';
import Pill from 'components/Pill';
import InlineList from 'components/InlineList';
import Box from 'components/Box';
import Flag from 'components/Flag';
import Icon from 'components/Icon';
import Text from 'components/Text';
import TeamsList from './common/TeamsList';
function AudienceTeamOrAllField(_ref) {
  var onAddTeams = _ref.onAddTeams,
    onRemoveTeam = _ref.onRemoveTeam,
    onSetEveryone = _ref.onSetEveryone,
    teams = _ref.teams,
    horizontal = _ref.horizontal,
    label = _ref.label,
    description = _ref.description;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FormField, {
    as: "fieldset",
    label: label || t('property_audience'),
    horizontal: horizontal
  }, teams.length === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pill, {
    as: "p"
  }, t('state_everyone')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    mt: "xs",
    icon: "plus",
    onClick: onAddTeams,
    size: "medium"
  }, t('actions_select_teams'))) : /*#__PURE__*/React.createElement(React.Fragment, null, description && /*#__PURE__*/React.createElement(Flag, {
    token: /*#__PURE__*/React.createElement(Icon, {
      vAlign: true,
      name: "info",
      dimmed: true
    }),
    spacing: "xs",
    my: "xs"
  }, /*#__PURE__*/React.createElement(Text, null, description)), /*#__PURE__*/React.createElement(TeamsList, {
    teams: teams,
    onRemoveTeam: onRemoveTeam
  }), /*#__PURE__*/React.createElement(Box, {
    mt: "xs"
  }, /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xs",
    top: "xs"
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "edit",
    onClick: onAddTeams,
    size: "medium"
  }, t('actions_edit_teams')), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    onClick: onSetEveryone
  }, t('actions_set_audience_to_everyone'))))));
}
export default AudienceTeamOrAllField;